const CALCULATION_DECIMALS = 4
const DISPLAY_DECIMALS = 2

const parsePrice = value => {
  if (value === '' || value === null || value === undefined) return null
  const num = parseFloat(value)
  return Number.isNaN(num) ? null : num
}

const roundTo = (value, decimals) => {
  const factor = 10 ** decimals
  return Math.round((value + Number.EPSILON) * factor) / factor
}

/** Margin price for UI (2dp). */
export const formatMarginPriceForDisplay = marginPrice => {
  const num = parsePrice(marginPrice)
  if (num === null) return ''
  return roundTo(num, DISPLAY_DECIMALS).toFixed(DISPLAY_DECIMALS)
}

/** Margin price for form state / calculations (4dp). */
export const formatMarginPriceForStorage = marginPrice => {
  const num = parsePrice(marginPrice)
  if (num === null) return ''
  return roundTo(num, CALCULATION_DECIMALS).toFixed(CALCULATION_DECIMALS)
}

export const calculateSellingPriceInclVat = (marginPrice, hasVat) => {
  const marginValue = parsePrice(marginPrice)
  if (marginValue === null || marginValue === 0) return 0
  const vatMultiplier = hasVat ? 1.2 : 1.0
  return roundTo(marginValue * vatMultiplier, CALCULATION_DECIMALS)
}

export const calculateSellingPriceInclVatFormatted = (marginPrice, hasVat) => {
  const price = calculateSellingPriceInclVat(marginPrice, hasVat)
  if (price === 0) return ''
  return roundTo(price, DISPLAY_DECIMALS).toFixed(DISPLAY_DECIMALS)
}

/** Derive margin (ex VAT) from selling price (inc VAT). Returns 4dp string for storage. */
export const calculateMarginPrice = (sellingPriceInclVat, hasVat) => {
  const sellingValue = parsePrice(sellingPriceInclVat)
  if (sellingValue === null || sellingValue === 0) return ''
  const vatMultiplier = hasVat ? 1.2 : 1.0
  return roundTo(sellingValue / vatMultiplier, CALCULATION_DECIMALS).toFixed(
    CALCULATION_DECIMALS,
  )
}
